import React from "react";

import "./Header.css"

const Header = () => {

    return (
        <nav>
            <h1>Hacker News</h1>
        </nav>
    )
}

export default Header;